/**
 * Atlas — Idle warning modal.
 *
 * Shown by AuthProvider when useIdleLogout fires its warn callback
 * (one minute before the hard logout). Counts down live so the user
 * sees how long they have. Clicking "Stay signed in" calls onStay,
 * which resets the idle timers. Letting the countdown hit zero hands
 * off to useIdleLogout's onLogout via its own timer — this modal
 * doesn't trigger the logout itself, it just nudges the user.
 */
import React, { useEffect, useState } from 'react';

export default function IdleWarningModal({ initialSecondsLeft, onStay, onLogoutNow }) {
  const [secondsLeft, setSecondsLeft] = useState(initialSecondsLeft);

  useEffect(() => {
    if (secondsLeft <= 0) {
      // useIdleLogout's own timer also fires onLogout independently;
      // calling here as well is redundant but harmless and avoids a
      // visible 0-second lull if the host's timer is slightly behind.
      onLogoutNow();
      return undefined;
    }
    const t = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [secondsLeft, onLogoutNow]);

  return (
    <div
      className="modal-backdrop"
      // Don't close on backdrop click — that would feel like activity
      // and contradict the "you've been idle" framing.
      onClick={(e) => e.stopPropagation()}
      style={{ zIndex: 9999 }}
    >
      <div className="modal" style={{ maxWidth: 420 }}>
        <div className="modal-head">
          <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--forest)' }}>
            Still there?
          </div>
        </div>
        <div className="modal-body" style={{ display: 'grid', gap: 12 }}>
          <div style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.5 }}>
            You'll be signed out in{' '}
            <strong style={{ color: 'var(--crimson)' }}>{secondsLeft}s</strong>{' '}
            for inactivity. Click "Stay signed in" to keep working.
          </div>
        </div>
        <div className="modal-foot" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="btn" onClick={onLogoutNow}>Sign out now</button>
          <button className="btn primary" onClick={onStay}>Stay signed in</button>
        </div>
      </div>
    </div>
  );
}
